<template>
  <div class="d-flex flex-column g-4">
    <InputView type="text" v-model:value="value.href" required>
      <template v-slot:title>
        <i class="fas fa-link"></i>
      </template>
    </InputView>
    <InputView type="text" v-model:value="value.text" required>
      <template v-slot:title>
        <i class="fas fa-text"></i>
      </template>
    </InputView>
    <div class="d-flex align-items-center g-4">
      <ButtonView type="normal" color="secondary" class="w-100" :active="value.target === '_self'" @click="value.target = '_self'">
        <i class="fas fa-link"></i>
      </ButtonView>
      <ButtonView type="normal" color="secondary" class="w-100" :active="value.target === '_blank'" @click="value.target = '_blank'">
        <i class="fas fa-arrow-up-right-from-square"></i>
      </ButtonView>
    </div>
    <ButtonView type="normal" color="primary" :disabled="!value.href || !/https:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(value.href)" class="w-100" @click="submit">
      <i class="fas fa-check-circle"></i>
    </ButtonView>
  </div>
</template>

<script setup>
import InputView from "../../../forms/inputs/InputView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";

const props = defineProps({
  editor: Object
});

const value = ref({
  text: props.editor.state.doc.textBetween(props.editor.state.selection.from, props.editor.state.selection.to),
  href: props.editor.getAttributes('link').href,
  target: props.editor.getAttributes('link').target ?? '_self'
});

const emit = defineEmits(["submit"]);

function submit() {
  emit("submit");
  props.editor.chain().focus().extendMarkRange('link').setLink({
    href: value.value.href,
    target: value.value.target
  }).command(({ tr }) => {
    tr.insertText(value.value.text);
    return true
  }).run();
}

</script>